/**
 * src/data/MediumMattersBank.js
 * Hardcoded scenario bank for Part 1: The Medium Matters.
 * Deprecates dynamic LLM generation for pure kinematic telemetry capture.
 */

export const mediumMattersBank = [
  {
    "id": "medium_01",
    "scenarioText": "The staging server just crashed 10 minutes before a major client demo, and you need the lead engineer to restart the instance immediately.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Server outages require immediate, synchronous attention where email is too slow and a call wastes critical typing time."
  },
  {
    "id": "medium_02",
    "scenarioText": "You notice a critical typo on the live homepage that is confusing customers and need the content manager to fix it right now.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Urgent, low-complexity tasks require immediate visibility without the formality of an email or the interruption of a call."
  },
  {
    "id": "medium_03",
    "scenarioText": "You are running five minutes late to the daily standup due to a prior meeting running over and need to let your squad know.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Quick status updates regarding attendance are best handled via instant messaging to avoid cluttering inboxes."
  },
  {
    "id": "medium_04",
    "scenarioText": "You need the hex code for the new brand color to finish a presentation due in an hour, and your designer is currently online.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Simple, rapid-fire asset requests are perfectly suited for instant messaging to get an immediate reply."
  },
  {
    "id": "medium_05",
    "scenarioText": "A new inbound lead just dropped into the CRM, and you want to quickly see if the West Coast rep has capacity to take it.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Assessing immediate bandwidth for a quick task is highly efficient over instant chat rather than waiting for an asynchronous email response."
  },
  {
    "id": "medium_06",
    "scenarioText": "You want to share a quick celebratory GIF with your pod because the team just hit their weekly milestone early.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Casual team bonding and informal celebrations thrive in chat environments where emoji reactions are native."
  },
  {
    "id": "medium_07",
    "scenarioText": "You need to quickly clarify whether a new Jira ticket requires a UI mock-up or just backend text copy.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Minor, binary clarifications on active workflow tickets are best handled via direct ping to avoid project stalls."
  },
  {
    "id": "medium_08",
    "scenarioText": "The catered lunch just arrived in the third-floor breakroom, and you want to notify the department before it gets cold.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Time-sensitive, informal logistical updates are ideal for team-wide chat channels."
  },
  {
    "id": "medium_09",
    "scenarioText": "You are locked out of the VPN and need IT to quickly send a push notification to your authenticator app.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "IT blockers require real-time troubleshooting that instant messaging facilitates far better than an asynchronous email."
  },
  {
    "id": "medium_10",
    "scenarioText": "You want to quickly coordinate who is taking notes in the all-hands meeting starting in two minutes.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Last-minute logistical coordination is perfectly suited for a quick direct message right before an event begins."
  },
  {
    "id": "medium_11",
    "scenarioText": "You need a quick thumbs-up from your manager on a drafted social media post before hitting publish in five minutes.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Approvals for low-stakes, time-sensitive external communications are ideal for real-time chat."
  },
  {
    "id": "medium_12",
    "scenarioText": "You are testing a new feature and need a peer to quickly log in and verify if they see the same front-end bug.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Real-time cooperative troubleshooting is highly efficient over instant messaging where immediate feedback is necessary."
  },
  {
    "id": "medium_13",
    "scenarioText": "You want to send an informal reminder for the team to submit their timesheets before the impending 5 PM cutoff.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Gentle administrative nudges are less abrasive and more quickly actioned when sent via team chat rather than a formal email."
  },
  {
    "id": "medium_14",
    "scenarioText": "You need to quickly ask a colleague if they have a five-minute window to jump on a call later this afternoon.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Coordinating ad-hoc synchronous time is best done asynchronously via chat to respect the other person's deep work schedule."
  },
  {
    "id": "medium_15",
    "scenarioText": "A minor CSS bug is making a button misaligned on the mobile view, and you want to give the front-end team a casual heads-up.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Non-critical bug notifications without immediate priority are easily dropped into a project chat channel for visibility."
  },
  {
    "id": "medium_16",
    "scenarioText": "You want to quickly confirm if the weekly sync is still happening since half the team is out of office today.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Rapid polling of team availability for routine meetings prevents inbox bloat and achieves much faster consensus."
  },
  {
    "id": "medium_17",
    "scenarioText": "You found a broken link in a draft blog post and need the author to swap the URL before their end-of-day deadline.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Slack/Teams",
    "feedbackRationale": "Small, easily actionable corrections are perfectly delivered via instant message to maintain workflow momentum."
  },
  {
    "id": "medium_18",
    "scenarioText": "You need the CFO to approve a $50k budget variance for the Q3 marketing spend.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Financial approvals mandate a rigid, auditable paper trail that instant messaging cannot reliably provide."
  },
  {
    "id": "medium_19",
    "scenarioText": "You are sending a signed, legally binding vendor contract to the procurement department for final processing.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Legal documents and finalized contracts must be transmitted via a secure, trackable medium for compliance purposes."
  },
  {
    "id": "medium_20",
    "scenarioText": "You need to submit your official two-week resignation notice to HR and your direct manager.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Resignations require formal documentation for human resources and payroll to officially begin offboarding procedures."
  },
  {
    "id": "medium_21",
    "scenarioText": "You are summarizing the kickoff meeting for a new enterprise client and need to share the project timeline attachments.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Complex external summaries with heavy attachments require the structure and asynchronous nature of a formal email."
  },
  {
    "id": "medium_22",
    "scenarioText": "You need to request formal manager approval for a two-week PTO block for your upcoming honeymoon next month.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Paid time off requests necessitate a formal record to ensure coverage and protect your employee benefits."
  },
  {
    "id": "medium_23",
    "scenarioText": "You must document a severe compliance violation made by a vendor to establish a formal record for legal review.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Compliance violations must be meticulously recorded in an uneditable, time-stamped format to protect the enterprise from liability."
  },
  {
    "id": "medium_24",
    "scenarioText": "You are distributing the comprehensive monthly financial performance report to the board of directors.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Board-level communications containing dense data are universally expected to be delivered via a formal, structured email."
  },
  {
    "id": "medium_25",
    "scenarioText": "You need to formally introduce two external stakeholders to one another so they can coordinate a joint press release.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "External business introductions require a professional, asynchronous platform where both parties can opt-in on their own time."
  },
  {
    "id": "medium_26",
    "scenarioText": "You are sending a finalized statement of work (SOW) to a freelance contractor outlining their deliverables for the next six months.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Agreements defining external work scopes must be documented clearly in a thread that both parties can reference legally."
  },
  {
    "id": "medium_27",
    "scenarioText": "You need to follow up on yesterday's external sales pitch by sending the client a detailed pricing proposal and SLA documentation.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "External sales proposals demand a professional format that can be easily forwarded to the client's internal procurement team."
  },
  {
    "id": "medium_28",
    "scenarioText": "You are formally announcing a massive overhaul to the company's hybrid work policy to all global employees.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Global policy changes require a permanent, company-wide broadcast mechanism to ensure equitable receipt of information."
  },
  {
    "id": "medium_29",
    "scenarioText": "You need to submit your quarterly travel expense receipts to the accounting team for reimbursement.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Expense reimbursements require structured attachments and a verifiable paper trail for internal auditing and tax purposes."
  },
  {
    "id": "medium_30",
    "scenarioText": "You are officially informing a software vendor that your company will be terminating their annual contract at the end of the quarter.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Contract terminations are legal actions that absolutely must be delivered via an official, date-stamped channel."
  },
  {
    "id": "medium_31",
    "scenarioText": "You need the legal team's final, documented approval on the new GDPR privacy policy updates before the website goes live.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Regulatory compliance approvals must be captured in a persistent format to shield the company from future litigation."
  },
  {
    "id": "medium_32",
    "scenarioText": "You are sharing a deeply detailed, 10-page project post-mortem document with cross-functional directors to review before next week's meeting.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Lengthy, complex documents intended for deep reading are best distributed via email so stakeholders can process them asynchronously."
  },
  {
    "id": "medium_33",
    "scenarioText": "You need to formally update your direct deposit bank details with the corporate payroll department.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "Sensitive financial updates require the security and formal routing capabilities inherently structured into enterprise email systems."
  },
  {
    "id": "medium_34",
    "scenarioText": "You are sending a finalized quarterly roadmap to an external partner outlining delivery dates for key API integrations.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Email",
    "feedbackRationale": "External milestone commitments must be formally logged in a thread that both organizations can point back to for accountability."
  },
  {
    "id": "medium_35",
    "scenarioText": "Your direct report has missed their SLA targets for the third week in a row, and you need to discuss their declining performance.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Performance discussions require nuanced tone, active listening, and empathy that text-based mediums strip away."
  },
  {
    "id": "medium_36",
    "scenarioText": "You have to inform a dedicated team member that their role is being eliminated due to a corporate restructuring.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Terminations are highly sensitive, emotionally charged events that demand the respect of a synchronous, face-to-face conversation."
  },
  {
    "id": "medium_37",
    "scenarioText": "The engineering team needs to design a completely new microservices architecture and requires a complex system mapping session.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Highly collaborative, abstract architectural planning relies on visual whiteboarding and real-time debate."
  },
  {
    "id": "medium_38",
    "scenarioText": "Two lead developers are in a heated, public argument in a Jira thread, and you need to de-escalate the conflict immediately.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Interpersonal conflicts must be moved to a synchronous voice or video channel to instantly break the cycle of textual misinterpretation."
  },
  {
    "id": "medium_39",
    "scenarioText": "You need to deliver a highly critical annual performance review that will unfortunately negatively impact an employee's end-of-year bonus.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Delivering bad news impacting compensation requires immediate bidirectional dialogue to manage emotional fallout and clarify feedback."
  },
  {
    "id": "medium_40",
    "scenarioText": "An enterprise client is furious about a major data loss incident and is threatening to churn their account immediately.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Retaining an angry client requires the immediate deployment of a humanizing, empathetic voice to rebuild broken trust."
  },
  {
    "id": "medium_41",
    "scenarioText": "The marketing team needs to brainstorm a completely new brand positioning strategy from scratch without any prior documentation.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Open-ended ideation and brainstorming thrive on the rapid, overlapping exchange of ideas that only a live meeting can support."
  },
  {
    "id": "medium_42",
    "scenarioText": "You need to pitch a controversial, highly nuanced pivot in the product roadmap to a skeptical executive board.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Persuading skeptics on a complex topic requires reading the room and dynamically adjusting your pitch based on real-time body language."
  },
  {
    "id": "medium_43",
    "scenarioText": "An employee is spreading sensitive rumors about a potential merger, and you need to privately shut the conversation down.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Addressing sensitive behavioral issues requires the privacy and immediate clarity of a live conversation to prevent misinterpretation."
  },
  {
    "id": "medium_44",
    "scenarioText": "You are conducting a final-round interview with an external candidate for a sensitive Director-level leadership position.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Assessing leadership qualities and cultural fit relies heavily on non-verbal cues and real-time conversational flow."
  },
  {
    "id": "medium_45",
    "scenarioText": "You need to negotiate the final, contentious terms of a high-stakes merger deal with the opposing legal counsel.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "High-stakes negotiations require real-time leverage assessment, tonal inflection, and immediate counter-proposals that email hinders."
  },
  {
    "id": "medium_46",
    "scenarioText": "You have to walk a deeply confused, non-technical client through a complex database migration process step-by-step.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Guiding a confused stakeholder requires synchronous screen-sharing and the ability to instantly pause when they express misunderstanding."
  },
  {
    "id": "medium_47",
    "scenarioText": "You need to give a peer constructive criticism about how they continuously interrupt women during cross-functional team meetings.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Correcting behavioral toxicity requires a delicate, private conversation where tone conveys support rather than purely hostile accusation."
  },
  {
    "id": "medium_48",
    "scenarioText": "You must console a direct report who just received devastating personal news and is asking for emergency leave.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "High emotional distress demands immediate human empathy and real-time verbal reassurance that text cannot replicate."
  },
  {
    "id": "medium_49",
    "scenarioText": "You are presenting the Q4 financial results to the company, where tone, nuance, and visual aids are critical to maintain morale.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Company-wide presentations concerning overall health require a unified, visible leadership presence to project stability and confidence."
  },
  {
    "id": "medium_50",
    "scenarioText": "The executive team must align on a sudden, drastic pivot in company strategy after a major competitor just launched a disruptive product.",
    "optionsArray": [
      "Slack/Teams",
      "Email",
      "Zoom/Call"
    ],
    "correctAnswer": "Zoom/Call",
    "feedbackRationale": "Existential corporate pivots require intense, real-time debate to rapidly forge consensus and align leadership on immediate next steps."
  }
];